import { render, staticRenderFns } from "./SDetailPurchaseLotComp.vue?vue&type=template&id=fe4e9630&"
import script from "./SDetailPurchaseLotComp.vue?vue&type=script&lang=js&"
export * from "./SDetailPurchaseLotComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports